<template>
  <div id="modalPreco" class="w3-modal" style="display: block">
    <div class="w3-modal-content w3-animate-zoom" style="max-width: 500px">
      <header class="w3-container">
        <span @click="$emit('fechar')" class="w3-button w3-display-topright">&times;</span>
        <h4 class="titulo texto-vermelho">Alteração de preço</h4>
        <h5 class="texto-cinza" >{{formatarValor(produtoSelecionado.produto_id, 0)}} - {{produtoSelecionado.nome}}</h5>
      </header>
      <div class="w3-container">
        <div class="w3-col s12">                
          <div class="w3-row">
            <div class="w3-col s6">
              <label>Novo preço R$</label>
              <input 
                min="0"
                type="number"
                autocomplete='off'
                onClick="this.select()"
                id="novo_preco_produto"
                ref="novo_preco_produto"
                class="w3-input w3-border" 
                style="margin-right: 5px !important;"
                v-model="produtoSelecionado.preco_temp"
                @change="calcularPreviaValorProdutoSelecionado()"
                v-on:keyup="calcularPreviaValorProdutoSelecionado()"
                v-on:blur="calcularPreviaValorProdutoSelecionado()"
              >
            </div>
            <div class="w3-col s6">
              <label>% Desconto</label>
              <input
                min="0"
                type="number"
                autocomplete='off'
                onClick="this.select()"
                class="w3-input w3-border"
                style="margin-left: 5px !important;"
                v-model="produtoSelecionado.perc_desconto_temp"
                @change="calcularPreviaValorProdutoSelecionado()"
                v-on:blur="calcularPreviaValorProdutoSelecionado()"
                v-on:keyup="calcularPreviaDescontoProdutoSelecionado()"
                v-on:keyup.enter="calcularPreviaValorProdutoSelecionado()"
              >
            </div>
            <div class="w3-col s12">
              <strong 
                class="link w3-left"
                style="margin-top: 10px;color: blue;" 
                @click="limparDescontoAlteracaoPreco()"
                v-if="formatarValor(produtoSelecionado.preco_venda_sem_desconto, 2) != formatarValor(produtoSelecionado.preco_temp, 2)">
                Desfazer novo preço: R$ {{formatarValor(produtoSelecionado.preco_venda_sem_desconto, 2)}}
              </strong>
            </div>
            <br/>
          </div>
        </div>
        <div class="w3-col s12 w3-center">
          <button 
            class="w3-button w3-theme" 
            style="margin-bottom: 5px;margin-top: 10px;"
            v-on:click="concluir()">
            <i class="fas fa-check-circle"></i> Concluir
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import VueNumeric from 'vue-numeric'
import Legenda from '@/components/Legendas' 
import formatarValorMixin from '@/mixins/formatarValorMixin'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  name: 'ModalCalcularDescontoProduto',
  
  components: {
    VueNumeric, Legenda
  },

  mixins:[formatarValorMixin],

  props:{
    produtoSelecionado: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },

    percentualDescontoMaximoF5: {
      required: true,
      type: Number,
      default: function () {
        return {}
      }
    },

    parEmpGerarBloqDescF5AcimaAut: {
      required: true,
      type: String,
      default: function () {
        return {}
      }
    },
  },

  data () {
    return {
      api: process.env.API,
    }
  },

  methods: {
    calcularPreviaDescontoProdutoSelecionado: function () {
      if (this.produtoSelecionado.perc_desconto_temp == 0){
        this.produtoSelecionado.preco_temp = this.produtoSelecionado.preco_venda_oculto;
        this.produtoSelecionado.total_item_temp = this.produtoSelecionado.preco_venda_oculto * this.produtoSelecionado.quantidade;
        this.produtoSelecionado.valor_desconto_temp = 0;
      }
      else {
        /*Calculando o preço em função do desconto*/
        this.produtoSelecionado.preco_temp = Biblioteca.arredondar(
          (
            /* Preço do produto */
            this.produtoSelecionado.preco_venda_oculto *
            (1 - this.produtoSelecionado.perc_desconto_temp * 0.01)
          ),
          /* Casas decimais*/
          2
        );

        this.produtoSelecionado.valor_desconto_temp = this.produtoSelecionado.preco_venda_oculto - this.produtoSelecionado.preco_temp;            
        this.produtoSelecionado.total_item_temp = this.produtoSelecionado.preco_temp * this.produtoSelecionado.quantidade;
      }
    },

    limparDescontoAlteracaoPreco: function(produto){
      this.produtoSelecionado.perc_desconto_temp = 0;
      this.produtoSelecionado.preco_temp = this.produtoSelecionado.preco_venda_sem_desconto;
      this.produtoSelecionado.preco_alterado = false;
    },

    calcularPreviaValorProdutoSelecionado: function () {
      if (!this.produtoSelecionado.preco_temp)
        return;

      this.produtoSelecionado.perc_desconto_temp = Biblioteca.arredondar((100 * (this.produtoSelecionado.preco_venda_oculto - this.produtoSelecionado.preco_temp) / this.produtoSelecionado.preco_venda_oculto), 4)
      this.produtoSelecionado.total_item_temp = this.produtoSelecionado.preco_temp * this.produtoSelecionado.quantidade;
      this.produtoSelecionado.valor_desconto_temp = this.produtoSelecionado.preco_venda_oculto - this.produtoSelecionado.preco_temp;
    },
    
    async concluir(){
      if (Biblioteca.valor(this.produtoSelecionado.perc_desconto_temp) > Biblioteca.valor(this.percentualDescontoMaximoF5)){
        
        if (this.parEmpGerarBloqDescF5AcimaAut == 'S'){
          let abortar = false;

          await swal({
            title: "Atenção",
            text: "Desconto superior ao definido para o usuário(" + Biblioteca.nPadrao(this.percentualDescontoMaximoF5, 4) + "%). " +
            "Caso continue, o pedido será bloqueado. Deseja continuar?",
            icon: "warning",
            buttons: {
              sim: "Sim",
              nao: "Não",
            },
          }).
          then((value) => {
            switch (value) {
              case "nao": abortar = true;
            }
          });
          
          if (abortar)
            return;
        } else {
          Biblioteca.exclamar(
            'Usuário não autorizado a dar este desconto! ' + 'Desconto aplicado: ' + Biblioteca.nPadrao(this.produtoSelecionado.perc_desconto_temp, 4) + '%. ' +
            'Produto: ' + Biblioteca.nPadrao(this.produtoSelecionado.produto_id, 0)
          );

          return;
        }
      }

      this.$emit('alterar', this.produtoSelecionado)
    },
  },
}
</script>
<style scoped>
  .tela-cheia{
    width: 100%!important;
    height: 100%!important;
    padding-top: 0%!important;
    padding-left: 0%!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/ModalCalcularDescontoProduto.vue